/**
 * Component default class name and class prefix.
 */
export const TABS_CLASSNAME = `lumx-tabs`;

export const TAB_PROVIDER_COMPONENT_NAME = 'TabProvider';
